import { IconFrame, type IconProps } from './icon.tsx';

export type { IconProps } from './icon.tsx';

export function HomeIcon(props: IconProps) {
  return (
    <IconFrame {...props}>
      <path d="M3 11.5 12 4l9 7.5" />
      <path d="M5.5 10v10h4.5v-6h4v6h4.5V10" />
    </IconFrame>
  );
}

export function BookIcon(props: IconProps) {
  return (
    <IconFrame {...props}>
      <path d="M4 19.5V5.5A2.5 2.5 0 0 1 6.5 3H20v14H6.5A2.5 2.5 0 0 0 4 19.5Z" />
      <path d="M4 19.5A2.5 2.5 0 0 0 6.5 22H20v-5" />
      <path d="M9 7.5h6" />
    </IconFrame>
  );
}

export function ClipboardIcon(props: IconProps) {
  return (
    <IconFrame {...props}>
      <rect x="5" y="4" width="14" height="17" rx="2" />
      <rect x="9" y="2" width="6" height="4" rx="1" />
      <path d="m9 14 2 2 4-4.5" />
    </IconFrame>
  );
}

export function SteeringWheelIcon(props: IconProps) {
  return (
    <IconFrame {...props}>
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="12" r="2.5" />
      <path d="M3.2 11.5 9.5 12" />
      <path d="m14.5 12 6.3-.5" />
      <path d="M12 14.5V21" />
    </IconFrame>
  );
}

export function UserIcon(props: IconProps) {
  return (
    <IconFrame {...props}>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21a8 8 0 0 1 16 0" />
    </IconFrame>
  );
}

export function ChevronLeftIcon(props: IconProps) {
  return (
    <IconFrame {...props}>
      <path d="m15 18-6-6 6-6" />
    </IconFrame>
  );
}

export function ChevronRightIcon(props: IconProps) {
  return (
    <IconFrame {...props}>
      <path d="m9 18 6-6-6-6" />
    </IconFrame>
  );
}

export function ChevronUpIcon(props: IconProps) {
  return (
    <IconFrame {...props}>
      <path d="m18 15-6-6-6 6" />
    </IconFrame>
  );
}

export function ChevronDownIcon(props: IconProps) {
  return (
    <IconFrame {...props}>
      <path d="m6 9 6 6 6-6" />
    </IconFrame>
  );
}

export function ArrowLeftIcon(props: IconProps) {
  return (
    <IconFrame {...props}>
      <path d="M19 12H5" />
      <path d="m12 19-7-7 7-7" />
    </IconFrame>
  );
}

export function ArrowRightIcon(props: IconProps) {
  return (
    <IconFrame {...props}>
      <path d="M5 12h14" />
      <path d="m12 5 7 7-7 7" />
    </IconFrame>
  );
}

export function CheckIcon(props: IconProps) {
  return (
    <IconFrame {...props}>
      <path d="m5 12.5 4.5 4.5L19 7" />
    </IconFrame>
  );
}

export function XIcon(props: IconProps) {
  return (
    <IconFrame {...props}>
      <path d="M6 6l12 12" />
      <path d="M18 6 6 18" />
    </IconFrame>
  );
}

export function BookmarkIcon(props: IconProps) {
  return (
    <IconFrame {...props}>
      <path d="M6.5 3h11v18L12 16.8 6.5 21Z" />
    </IconFrame>
  );
}

export function ShuffleIcon(props: IconProps) {
  return (
    <IconFrame {...props}>
      <path d="M16 3h5v5" />
      <path d="M3 20 21 3" />
      <path d="M21 16v5h-5" />
      <path d="m15 15 6 6" />
      <path d="m3 4 5.5 5.5" />
    </IconFrame>
  );
}

export function MenuIcon(props: IconProps) {
  return (
    <IconFrame {...props}>
      <path d="M4 6h16" />
      <path d="M4 12h16" />
      <path d="M4 18h16" />
    </IconFrame>
  );
}

export function SunIcon(props: IconProps) {
  return (
    <IconFrame {...props}>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2" />
      <path d="m5.3 5.3 1.4 1.4M17.3 17.3l1.4 1.4M5.3 18.7l1.4-1.4M17.3 6.7l1.4-1.4" />
    </IconFrame>
  );
}

export function MoonIcon(props: IconProps) {
  return (
    <IconFrame {...props}>
      <path d="M20.5 14.5A8.5 8.5 0 0 1 9.5 3.5a8.5 8.5 0 1 0 11 11Z" />
    </IconFrame>
  );
}

export function MonitorIcon(props: IconProps) {
  return (
    <IconFrame {...props}>
      <rect x="3" y="4" width="18" height="12" rx="2" />
      <path d="M8 20h8" />
      <path d="M12 16v4" />
    </IconFrame>
  );
}

/** Settings drawn as two sliders. */
export function SettingsIcon(props: IconProps) {
  return (
    <IconFrame {...props}>
      <path d="M4 7h9.5M18.5 7H20" />
      <circle cx="16" cy="7" r="2.5" />
      <path d="M4 17h1.5M10.5 17H20" />
      <circle cx="8" cy="17" r="2.5" />
    </IconFrame>
  );
}

export function HistoryIcon(props: IconProps) {
  return (
    <IconFrame {...props}>
      <path d="M3 12a9 9 0 1 0 2.8-6.5L3 8" />
      <path d="M3 3v5h5" />
      <path d="M12 7.5V12l3 2" />
    </IconFrame>
  );
}

export function PlayIcon(props: IconProps) {
  return (
    <IconFrame {...props}>
      <path d="M7 4.5v15l12-7.5Z" fill="currentColor" />
    </IconFrame>
  );
}

export function LockIcon(props: IconProps) {
  return (
    <IconFrame {...props}>
      <rect x="5" y="11" width="14" height="10" rx="2" />
      <path d="M8 11V7a4 4 0 0 1 8 0v4" />
    </IconFrame>
  );
}

export function ExternalLinkIcon(props: IconProps) {
  return (
    <IconFrame {...props}>
      <path d="M14 4h6v6" />
      <path d="M20 4 11 13" />
      <path d="M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5" />
    </IconFrame>
  );
}

export function WarningIcon(props: IconProps) {
  return (
    <IconFrame {...props}>
      <path d="M12 3.5 2.5 20h19Z" />
      <path d="M12 10v4.5" />
      <path d="M12 17.5h.01" />
    </IconFrame>
  );
}

export function InfoIcon(props: IconProps) {
  return (
    <IconFrame {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11v5" />
      <path d="M12 8h.01" />
    </IconFrame>
  );
}
